/**
 * Search and filter boxes are not login fields: keep password managers
 * (LastPass, 1Password…) from offering to fill them.
 */
export const SEARCH_INPUT_PROPS = {
  type: "search",
  autoComplete: "off",
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-form-type": "other",
} as const;
